<div class="full-page">
  <div class="container">
    <div class="login-container">
      <div class="d-flex align-items-center justify-content-center">
        <div class="img-wrapper">
          <img src="assets/images/login-registration/Logo.png" class="logo" />
        </div>
      </div>
      <div class="bg-white content-login rounded-4">
        <div class="font-size-14" [innerHTML]="'login.page.description' | translate | markdownTranslate"></div>
        <fgbcl-errors></fgbcl-errors>
        <div class="w-100">
          <fgb-tm-user-login></fgb-tm-user-login>
        </div>
        <div class="w-100">
          <a [routerLink]="['/register/guardian']">
            <div class="btn btn-primary btn-block font-size-14 d-flex justify-content-center">
              <span
                >{{ 'login.create.account.with' | translate }} <img src="assets/images/ticketmaster.svg" class="tm-logo mx-1" />
              </span>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
